import { Button, Image, UIText3 } from '@cian/ui-kit';

import cn from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { NBSP } from 'shared/constants/common';
import { ETestIds } from '../../../constants/testIds';
import { selectMasterButton } from '../../../selectors/landing';
import { useFillApplicationButtonClick } from './hooks/useFillApplicationButtonClick';
import * as styles from './styles.css';
import { IMasterButtonProps } from './types';

export const FillApplicationButton: React.FC<IMasterButtonProps> = ({ currentButtonType }) => {
  const enabledButton = useSelector(selectMasterButton);
  const handleClickOnMasterButton = useFillApplicationButtonClick(currentButtonType);

  return (
    <div
      className={cn(styles['wrapper'], enabledButton === currentButtonType && styles['active'])}
      data-testid={`king-btn-${currentButtonType}`}
    >
      <Button size="M" onClick={handleClickOnMasterButton}>
        Заполнить заявку на Циане
      </Button>
      <div>
        <UIText3 textAlign="center" color="text-secondary-default">
          Заявка{NBSP}— единая для всех банков.
        </UIText3>
        <UIText3 textAlign="center" color="text-secondary-default">
          Перед заполнением попросим авторизоваться.
        </UIText3>
      </div>
      <div className={cn(styles['img'])}>
        <Image
          src={'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_promo_frontend/cat.png'}
          alt="background"
          preloader
          data-testid={ETestIds.PresentationImg}
        />
      </div>
    </div>
  );
};
